import { AUTH_COOKIE } from '@anm/constants/auth';
import * as cookie from '@anm/helpers/cookie';
export var getAuthToken = function getAuthToken() {
  var token = cookie.get(AUTH_COOKIE);
  return token || null;
};
export var setAuthToken = function setAuthToken(token) {
  cookie.set(AUTH_COOKIE, token, 30);
  return token || null;
};